import React, { useEffect } from 'react';

const ZCreditWebCheckoutIframe = ({ iframeUrl, onSuccessCallback }) => {
    useEffect(() => {
        // Listen for messages from the iframe
        const handleMessage = (event) => {
            if (event.data.type === 'SUCCESSFUL_PAYMENT' && event.data.success) {
                onSuccessCallback();
            }
        };

        window.addEventListener('message', handleMessage);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <iframe
            id="webcheckout-iframe"
            src={ iframeUrl }
            style={ { width: '100%', height: '750px', border: 'none', borderRadius: '10px' } }
        />
    );
};

export default ZCreditWebCheckoutIframe;